var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("Editor", {
        attrs: {
          "initial-value": _vm.editorContent,
          init: _vm.editorInit,
          disabled: _vm.editDisabled
        },
        on: { onChange: _vm.onChangeHandler },
        model: {
          value: _vm.editorContent,
          callback: function($$v) {
            _vm.editorContent = $$v
          },
          expression: "editorContent"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }